import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getFeedKey, getPostKey, getPostsKey } from '../../utils/keys';
import { pinnedPostsFilter } from './filters';
export const useHidePost = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((variables) => client.posts.hide(variables), {
        onSettled: (data, error, variables) => {
            const postKey = getPostKey(variables.id);
            queryClient.invalidateQueries(postKey);
            const postsKey = getPostsKey();
            queryClient.invalidateQueries(postsKey);
            queryClient.invalidateQueries({ ...pinnedPostsFilter, active: true });
            const feedKey = getFeedKey();
            queryClient.invalidateQueries(feedKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useHidePost.js.map